import React, {Component} from "react";
import { Roles } from "../constants/insurance/constant";
import "../style/errorScreen.css";
import { returnRoleBasedOnRoleId } from "../helper/utils";
class ErrorScreen extends Component{
  componentWillMount(){
    // eslint-disable-next-line eqeqeq
    if( localStorage.getItem("user_details") && ( localStorage.getItem("roleName") == "null" || !localStorage.getItem("roleName") ) ){
      let user = JSON.parse(localStorage.getItem("user_details"))
      let role = this.checkRoleId(user);
      user.roleId = Roles[role];
      localStorage.setItem("roleName",role);
      localStorage.setItem("user_details", JSON.stringify(user));
      if(role)
        window.location.reload()
    }
    else{
      this.props.history.goBack();
    }
  }

  returnRole(roleId) {
    return returnRoleBasedOnRoleId(roleId);
  };

  checkRoleId(users){
    let role = this.returnRole(users.roleId);
    if(role == null && users.rolesFeatures && users.rolesFeatures.roles){
       users.rolesFeatures.roles.forEach(elem =>{
         if(this.returnRole(elem.roleId) != null && role == null){
          role = this.returnRole(elem.roleId);
        }
      })
      return role;
    }else{
      return role;
    }
  }

  render(){
    return(
        <div className="error-div">
        </div>
    )
    }
}
export default ErrorScreen;
